import React, { useEffect, useState } from 'react';
import { View, StyleSheet, TouchableOpacity, ScrollView } from 'react-native';
import BoilerPlate from '../boilerPlate/BoilerPlate';
import { BottomBarDLSType, ButtonSizeDLS, ButtonTypeDLS, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, TypographyTypeDLS } from '@voltmoney/schema';
import BottomBar from '../../bottomBarDLS/bottomBarDLS';
import Divider from '../../divider/Divider';
import Typography from '../../typography/Typography';
import Icon from '../../icon/Icon';
import Radio from '../../radio/Radio';
export var filtersSelected;
(function (filtersSelected) {
    filtersSelected["RENEWAL"] = "RENEWAL";
    filtersSelected["LENDER"] = "LENDER";
})(filtersSelected || (filtersSelected = {}));
export var renewalType;
(function (renewalType) {
    renewalType["ALL"] = "All";
    renewalType["RENEWAL_PENDING"] = "Renewal pending";
    renewalType["EXPIRED"] = "Expired";
})(renewalType || (renewalType = {}));
export var LenderType;
(function (LenderType) {
    LenderType["ALL"] = "All";
    LenderType["Tata"] = "Tata";
    LenderType["Bajaj"] = "Bajaj";
})(LenderType || (LenderType = {}));
const RenewalFilter = ({ height, filterObj, onBackPressAction, applyRenewalFilterAction, triggerAction, }) => {
    const [statusSelected, setStatusSelected] = useState(filtersSelected.RENEWAL);
    const [renewalSelected, setRenewalSelected] = useState([]);
    const [lenderSelected, setLenderSelected] = useState([]);
    const renewalTypes = ['ALL', 'RENEWAL_PENDING', 'EXPIRED'];
    const lenderTypes = ['ALL', 'Tata', 'Bajaj'];
    useEffect(() => {
        if (filterObj?.filter?.renewalStatus !== undefined)
            setRenewalSelected([...filterObj?.filter?.renewalStatus]);
        if (filterObj?.filter?.lenders !== undefined)
            setLenderSelected([...filterObj?.filter?.lenders]);
    }, [filterObj]);
    const handleRenewalFilter = async () => {
        await triggerAction({
            ...applyRenewalFilterAction,
            payload: {
                renewalSelected,
                lenderSelected,
                ...applyRenewalFilterAction.payload
            }
        });
    };
    const headerView = () => {
        return (React.createElement(View, { style: { height: 60, flexDirection: 'row', justifyContent: 'space-between', padding: 16 } },
            React.createElement(Typography, { label: "Filters", fontSize: FontSizeTokens.LG, fontWeight: "700", lineHeight: 26, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Poppins }),
            React.createElement(TouchableOpacity, { onPress: handleRenewalFilter },
                React.createElement(Icon, { name: IconTokens.CrossIcon, size: IconSizeTokens.XXL }))));
    };
    const footerScreen = () => {
        return (React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
            React.createElement(View, { style: { width: '50%' } },
                React.createElement(BottomBar, { typeDLS: BottomBarDLSType.TYPE_B, btnLabel: 'Reset filter', btnTypeDLS: ButtonTypeDLS.SECONDARY, btnSizeDLS: ButtonSizeDLS.MEDIUM, onPress: () => {
                        setRenewalSelected([]);
                        setLenderSelected([]);
                    } })),
            React.createElement(View, { style: { width: '50%' } },
                React.createElement(BottomBar, { typeDLS: BottomBarDLSType.TYPE_A, btnLabel: 'Apply ', btnTypeDLS: ButtonTypeDLS.PRIMARY, btnSizeDLS: ButtonSizeDLS.MEDIUM, onPress: handleRenewalFilter }))));
    };
    const handleItemSelect = (item, statusSelected) => {
        if (statusSelected === filtersSelected.RENEWAL) {
            if (item === 'ALL') {
                if (renewalSelected.includes(item)) {
                    setRenewalSelected([]);
                }
                else {
                    setRenewalSelected([...renewalTypes]);
                }
            }
            else {
                if (renewalSelected.includes(item)) {
                    setRenewalSelected((prevSelectedItems) => prevSelectedItems.filter((val) => val !== 'ALL'));
                    setRenewalSelected((prevSelectedItems) => prevSelectedItems.filter((val) => val !== item));
                }
                else {
                    if (renewalSelected?.length === renewalTypes?.length - 2) {
                        setRenewalSelected([...renewalTypes]);
                    }
                    else
                        setRenewalSelected((prevSelectedItems) => [
                            ...prevSelectedItems,
                            item
                        ]);
                }
            }
        }
        else if (statusSelected === filtersSelected.LENDER) {
            if (item === 'ALL') {
                if (lenderSelected.includes('ALL')) {
                    setLenderSelected([]);
                }
                else {
                    setLenderSelected([...lenderTypes]);
                }
            }
            else {
                if (lenderSelected.includes(item)) {
                    setLenderSelected((prevSelectedItems) => prevSelectedItems.filter((val) => val !== 'ALL'));
                    setLenderSelected((prevSelectedItems) => prevSelectedItems.filter((val) => val !== item));
                }
                else {
                    if (lenderSelected?.length === lenderTypes?.length - 2) {
                        setLenderSelected([...lenderTypes]);
                    }
                    else
                        setLenderSelected((prevSelectedItems) => [
                            ...prevSelectedItems,
                            item
                        ]);
                }
            }
        }
    };
    const filterScreen = () => {
        return (React.createElement(View, { style: { flexDirection: 'row', height: height - 133 } },
            React.createElement(View, { style: { width: '40%', paddingTop: 12, backgroundColor: '#F9FAFB' } },
                React.createElement(TouchableOpacity, { style: { paddingHorizontal: 12 }, onPress: () => { setStatusSelected(filtersSelected.RENEWAL); } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'Customer type', color: statusSelected === filtersSelected.RENEWAL ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal })),
                React.createElement(View, { style: { marginVertical: 12 } },
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                React.createElement(TouchableOpacity, { style: { paddingHorizontal: 12 }, onPress: () => { setStatusSelected(filtersSelected.LENDER); } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'Lender', color: statusSelected === filtersSelected.LENDER ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal })),
                React.createElement(View, { style: { marginVertical: 12 } },
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }))),
            React.createElement(View, { style: {
                    width: 1,
                    backgroundColor: '#E4E7EC',
                    height: '100%'
                } }),
            React.createElement(ScrollView, { nestedScrollEnabled: true },
                statusSelected === filtersSelected.RENEWAL && renewalTypes.map((item) => {
                    return (React.createElement(View, { style: {
                            paddingLeft: 16,
                            paddingRight: 16,
                            paddingTop: 16,
                        } },
                        React.createElement(TouchableOpacity, { style: {
                                flexDirection: 'row',
                                alignContent: 'center',
                                alignItems: 'center',
                                height: 20,
                                zIndex: 1
                            }, onPress: () => {
                                handleItemSelect(item, statusSelected);
                            }, activeOpacity: 0.6 },
                            React.createElement(Radio, { isChecked: renewalSelected.includes(item), onPressChecked: () => {
                                    handleItemSelect(item, statusSelected);
                                }, onPressUnChecked: () => {
                                    handleItemSelect(item, statusSelected);
                                } }),
                            React.createElement(View, { style: { marginLeft: 8 } },
                                React.createElement(Typography, { label: renewalType[item], fontSize: FontSizeTokens.MD, lineHeight: 24, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter }))),
                        React.createElement(View, { style: { marginTop: 16 } },
                            React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }))));
                }),
                statusSelected === filtersSelected.LENDER && lenderTypes.map((item) => {
                    return (React.createElement(View, { style: {
                            paddingLeft: 16,
                            paddingRight: 16,
                            paddingTop: 16,
                        } },
                        React.createElement(TouchableOpacity, { style: {
                                flexDirection: 'row',
                                alignContent: 'center',
                                alignItems: 'center',
                                height: 20,
                                zIndex: 1
                            }, onPress: () => {
                                handleItemSelect(item, statusSelected);
                            }, activeOpacity: 0.6 },
                            React.createElement(Radio, { isChecked: lenderSelected.includes(item), onPressChecked: () => {
                                    handleItemSelect(item, statusSelected);
                                }, onPressUnChecked: () => {
                                    handleItemSelect(item, statusSelected);
                                } }),
                            React.createElement(View, { style: { marginLeft: 8 } },
                                React.createElement(Typography, { label: LenderType[item], fontSize: FontSizeTokens.MD, lineHeight: 24, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter }))),
                        React.createElement(View, { style: { marginTop: 16 } },
                            React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }))));
                }))));
    };
    const renderContent = () => {
        return (React.createElement(View, null,
            headerView(),
            React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }),
            filterScreen()));
    };
    return (React.createElement(BoilerPlate, { height: height, backgroundColor: ColorTokens.White, bottomChildren: footerScreen() },
        React.createElement(React.Fragment, null, renderContent())));
};
const styles = StyleSheet.create({});
export default RenewalFilter;
